import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

export interface ComposerKeyType {
  singular: LocalesKey;
  composeButton: LocalesKey;
  composeModalTitle: LocalesKey;
  loading: LocalesKey;
  studioRender: LocalesKey;
  aiImageryTool: LocalesKey;
  comingSoon: LocalesKey;
  renderRequested: LocalesKey;
  renderRequestFailed: LocalesKey;
  requestRender: LocalesKey;
  generatingRender: LocalesKey;
  generatingRenderMessage: LocalesKey;
  createdRenders: LocalesKey;
  backToScene: LocalesKey;
  generationModeCompositeRender: LocalesKey;
  generationModeLifestyle: LocalesKey;
  generatingLifestyle: LocalesKey;
  generatingLifestyleMessage: LocalesKey;
  lifestylePromptPlaceholder: LocalesKey;
  addReferences: LocalesKey;
  renderCancelled: LocalesKey;
  backgroundDefault: LocalesKey;
  backgroundBlack: LocalesKey;
  backgroundWhite: LocalesKey;
  backgroundGray: LocalesKey;
  backgroundCustom: LocalesKey;
  backgroundColorPicker: LocalesKey;
  productsLibrary: LocalesKey;
  productsLibraryHint: LocalesKey;
  releaseToPlace: LocalesKey;
  noProductsFound: LocalesKey;
  composeDisabledMissingModel: LocalesKey;
  productLoadFailed: LocalesKey;
}

export const composerKeys = keyPathMirror<ComposerKeyType, string>(
  {
    singular: null,
    composeButton: null,
    composeModalTitle: null,
    loading: null,
    studioRender: null,
    aiImageryTool: null,
    comingSoon: null,
    renderRequested: null,
    renderRequestFailed: null,
    requestRender: null,
    generatingRender: null,
    generatingRenderMessage: null,
    createdRenders: null,
    backToScene: null,
    generationModeCompositeRender: null,
    generationModeLifestyle: null,
    generatingLifestyle: null,
    generatingLifestyleMessage: null,
    lifestylePromptPlaceholder: null,
    addReferences: null,
    renderCancelled: null,
    backgroundDefault: null,
    backgroundBlack: null,
    backgroundWhite: null,
    backgroundGray: null,
    backgroundCustom: null,
    backgroundColorPicker: null,
    productsLibrary: null,
    productsLibraryHint: null,
    releaseToPlace: null,
    noProductsFound: null,
    composeDisabledMissingModel: null,
    productLoadFailed: null
  },
  'models.composer.'
);
